import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, message, Spin } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

interface SectorData {
  id: number;
  descripcion: string;
}

interface EquipoData {
  id: number;
  descripcion: string;
  sector: {
    id: number;
    descripcion: string;
  };
  id_empresa: number;
  id_sucursal: number;
  alta: number;
}

const EditarEquipos: React.FC = () => {
  const {user} = useAuth0();
  const empresa = user?.id_empresa;
  const sucursal = user?.id_sucursal;
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const { getAccessTokenSilently , isLoading } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [sectores, setSectores] = useState<SectorData[]>([]);
  const [loadingSectores, setLoadingSectores] = useState(false);
  const [equipo, setEquipo] = useState<EquipoData[]>([]);
  const [initialLoading, setInitialLoading] = useState(true);
  // Cargar los datos del insumo seleccionado
  const fetchSectores = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/listar_sectores/${empresa}/${sucursal}`, {     method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error al cargar los sectores');
      }

      const data = await response.json();
      // Establecer los valores en el formulario
      setSectores(data);
      console.log('sectores',data)
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al cargar los datos del equipo');
    }
  };

  const fetchEquipo = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/editar_equipos/${empresa}/${sucursal}/${id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error al cargar el equipo');
      }

      const data = await response.json();
      // Establecer los valores en el formulario
      form.setFieldsValue({
        sector: data.sector.id,
        descripcion: data.descripcion,
        alta: data.alta,
      });
      console.log('equipo',data)
      setEquipo(data);
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al cargar los datos del equipo');
    }
  };
 
  useEffect(() => {
    if(isLoading){
      return;
    }
    
    const loadInitialData = async () => {
      setInitialLoading(true);
      try {
        await Promise.all([fetchSectores(), fetchEquipo()]);
      } catch (error) {
        console.error('Error loading initial data:', error);
      } finally {
        setInitialLoading(false);
      }
    };

    loadInitialData();
  }, [id, form, isLoading, empresa, sucursal]);

  const onFinish = async (values: any) => {
    setButtonLoading(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/editar_equipos/${empresa}/${sucursal}/${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(values),
      });

      if (!response.ok) {
        throw new Error('Error al actualizar el equipo');
      }

      message.success('Equipo actualizado correctamente');
      navigate('/listar_equipos'); // Redirigir después de actualizar
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al actualizar el equipo');
    } finally {
      setButtonLoading(false);
    }
  };

  return (
    <Spin spinning={initialLoading} tip="Cargando datos...">
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ maxWidth: 600, margin: '20px auto' }}
      >
        <Form.Item 
        name="sector" 
        label="Sector" 
        rules={[{ required: true, message: 'Por favor seleccione un sector' }]}
      >
        <Select
          placeholder="Seleccione un sector"
          loading={loadingSectores}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.children as unknown as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
        >
          {sectores.map(sector => (
            <Select.Option key={sector.id} value={sector.id}>
              {sector.descripcion}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="descripcion"
        label="Descripción"
        rules={[
          { required: true, message: 'Por favor ingrese la descripción'},
          { max: 40, message: 'La descripción no puede exceder los 40 caracteres' }
        ]}
      >
        <Input maxLength={40} />
      </Form.Item>

      <Form.Item
        name="alta"
        label="Estado"
        rules={[{ required: true, message: 'Por favor seleccione el estado' }]}
      >
        <Select>
          <Select.Option value={1}>Activo</Select.Option>
          <Select.Option value={0}>Inactivo</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item>
        <Button 
        type="primary"
         htmlType="submit" 
         loading={buttonLoading}
         disabled={buttonLoading}
         >
          {buttonLoading ? 'Actualizando...' : 'Actualizar'}
        </Button>
        <Button 
          style={{ marginLeft: 8 }} 
          onClick={() => navigate('/listar_equipos')}
        >
          Listar
        </Button>
      </Form.Item>
    </Form>
    </Spin>
  );
};

export default EditarEquipos;   